import React, {Component} from 'react';
import './ContactUsModal.css'
import {modal_rdv, services} from '../../constants'
import {SimpleModal} from "./Modals";
import Contact from "../Contact/Contact";
import Rdv from "../Rdv/Rdv";
class RdvModal extends Component {
    render() {
        return (
            <div className="artboard">
                <div className="card">

                    <div className="card__side card__side--back">
                        <div className="card__cover">
                            <h4 className="card__heading">
                                <span className="card__heading-span">{services.action}</span>
                            </h4>
                        </div>
                        <div className="card__details">
                            <SimpleModal title={this.props.title} >
                                <Rdv/>
                            </SimpleModal>
                        </div>
                    </div>

                    <div className="card__side card__side--front">
                        <div className="card__theme">
                            <div className="card__theme-box">
                                <p className="card__subject">24/24</p>
                                <p className="card__title">{modal_rdv.rdv}</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}

export default RdvModal;